var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.424,
    height: 29.502,
    viewBox: "0 0 23.424 29.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ppt",
    transform: "translate(-1.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9793",
    "data-name": "Path 9793",
    d: "M76.159,26.868A2.637,2.637,0,0,1,73.52,29.5H55.374a2.637,2.637,0,0,1-2.639-2.634V2.634A2.637,2.637,0,0,1,55.374,0h11.3a1.981,1.981,0,0,1,1.4.58l7.509,7.51a1.973,1.973,0,0,1,.578,1.4Z",
    transform: "translate(-51.455 0)",
    fill: "#faca2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9796",
    "data-name": "Path 9796",
    d: "M317.328,11.591h-6.706a1.785,1.785,0,0,1-1.784-1.785V3.1a1.961,1.961,0,0,1,.58.4l7.51,7.51a1.961,1.961,0,0,1,.4.579Z",
    transform: "translate(-292.802 -2.922)",
    fill: "#fcda6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13789",
    "data-name": "Path 13789",
    d: "M3.524,21.284A.524.524,0,0,1,3,20.76V15.524A.524.524,0,0,1,3.524,15H5.095a2.095,2.095,0,1,1,0,4.189H4.047V20.76A.524.524,0,0,1,3.524,21.284Zm.524-3.142H5.095a1.047,1.047,0,1,0,0-2.095H4.047Z",
    transform: "translate(2.661 -0.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13790",
    "data-name": "Path 13790",
    d: "M8.524,21.284A.524.524,0,0,1,8,20.76V15.524A.524.524,0,0,1,8.524,15h1.571a2.095,2.095,0,1,1,0,4.189H9.047V20.76A.524.524,0,0,1,8.524,21.284Zm.524-3.142h1.047a1.047,1.047,0,1,0,0-2.095H9.047Z",
    transform: "translate(2.897 -0.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13791",
    "data-name": "Path 13791",
    d: "M15.024,21.284a.524.524,0,0,1-.524-.524V15.524a.524.524,0,1,1,1.047,0V20.76A.524.524,0,0,1,15.024,21.284Z",
    transform: "translate(3.205 -0.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13792",
    "data-name": "Path 13792",
    d: "M16.665,16.047H13.524a.524.524,0,1,1,0-1.047h3.142a.524.524,0,0,1,0,1.047Z",
    transform: "translate(3.134 -0.559)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.629e873efe7c2e0a5bd956f09cb6913a.svg";
export { ForwardRef as ReactComponent };